import React, { useContext } from 'react'
import { Link } from 'gatsby'
import ExternalLink from 'components/external-link'
import classNames from 'classnames'
import CardContext from 'context/card'
import paths from 'data/paths.json'

export default function Button(props){
    const {
        to,
        text,
        children = 'Discover',
        download,
        debug,
        attributes,
        style = {},
        className,
        icon,
        variant,
        outline,
        disabled,
        whereToBuy,
        downloads,
        product,
    } = props

    const myProps = {
        ...attributes,
        disabled,
        style,
        className: classNames(
            'btn',
            { 'outline': outline },
            icon,
            variant,
            attributes?.className,
            className,
        ),
    }
    
    const { isHovered } = useContext(CardContext) || {}
    if(isHovered || props.isHovered) myProps['data-hovered'] = true

    if(debug) {
        // console.log('isCard:', isCard, 'isHovered:', isHovered)
        // console.log('props', props)
        // console.log('myProps', myProps)
        console.log(props)
    }

    if(whereToBuy && product) {        
        return (
            <a
                href='#obn'
                data-product={product?.gtin}
                {...myProps}
            >
                Where To Buy
            </a>
        )
    } else if(downloads && product){
        const base = paths.root.downloads.path

        return (
            <Link
                to={base + `/?product=${encodeURIComponent(product?.name)}`}
                {...myProps}
            >
                {children ? children : text}
            </Link>
        )
    } else if(to) {
        myProps.to = to
        if(to.startsWith('http')) {
            myProps.iconColor = props.iconColor
            myProps.size = props.size
            myProps.debug = props.debug
            return (
                <ExternalLink {...myProps}>
                    {children}
                </ExternalLink>
            )
        } else {
            return (
                <Link {...myProps}>
                    {children}
                </Link>
            )
        }
    } else if(download){
        return (
            <a
                href={download}
                target='_blank'
                rel='noreferrer noopener'
                {...myProps}
            >
                {children}
            </a>
        )
    } else {
        if(props.onClick) myProps.onClick = props.onClick
        return (
            <button {...myProps}>
                {children}
            </button>
        )
    }
}
